<template>
    <div class="title-model">
        <div class="title-model-container"> 
            <div class="model-title"> 
                <h2>{{ title }}</h2>
            </div>
            <div class="title-model-content"> 
                <h4 :hidden="content3">{{ content }}</h4>
                <h4 :hidden="!content1">{{ content1 }}</h4>
                <p :hidden="!content3"><strong>{{ content }}</strong></p>
                <p v-if="content2"><strong> {{ content2 }}</strong></p>
                <p v-if="content3"><strong> {{ content3 }}</strong> </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TitleModel',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Default Title'
    },
    content: {
      type: String,
      required: true, 
    },
    content1: {
      type: String, 
    },
    content2:{
        type: String, 
    },
    content3:{
        type: String, 
    } 
  }
}
</script>

<style lang="scss" scoped>

@media screen and (max-width: 767px)and (min-width: 0px){
    .model-title ,.title-model {
        width: 100% !important; 
    }  
}

@media screen and (min-width: 767px) and (max-width: 1199px){
    .model-title  {
        width: 60% !important; 
    }   
}

.title-model {    
    position: relative;
    padding-top: 25px;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    width: 80%; 
    margin: auto;
    .title-model-container{
        position: relative;
        z-index: 99;
        .model-title { 
            background-color: #040435;
            font-weight: normal;
            border-radius: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            width: 50%;
            margin: auto;
            color: var(--wp--preset--color--accent);
           
        }
        .title-model-content{ 
            text-align: center;
            padding-top: 20px ;
            padding-bottom: 20px ;
            h4{
                font-size: 25px;
            }
        }
    }
}

</style>